import { AvailabilityMethod } from 'generated-graphql/graphql';

// Takes a bare string so callers holding an untyped API value don't have to cast.
export const isRoundRobinMethod = (
  method: string | null | undefined
): boolean => !!method && method !== AvailabilityMethod.Collective;
